import React, { useState } from "react";
import { User, FileText, ChevronDown, ChevronUp } from "lucide-react";
import { useNavigate } from "react-router-dom";
import logo from '../../../../../assets/Logo-branco.png'

export default function HeaderPerfil() {
  const navigate = useNavigate();
  const [subMenuVisible, setSubMenuVisible] = useState(false);

  const toggleSubMenu = () => setSubMenuVisible(!subMenuVisible);

  const MinhaConta = () => {
    navigate("/area-restrita/colaborador/minha-conta");
    setSubMenuVisible(false);
  };

  const TermosDeUso = () => {
    navigate("/area-restrita/colaborador/termos");
    setSubMenuVisible(false);
  };

  // Dados do usuário do localStorage
  const usuarioLogado = JSON.parse(localStorage.getItem("usuario")) || {};
  const nomeUsuario = usuarioLogado.nome || "Usuário";
  const fotoUsuario = usuarioLogado.foto && usuarioLogado.foto.trim() !== "" 
    ? usuarioLogado.foto 
    : "https://www.gravatar.com/avatar/?d=mp&s=200";

  // Função para pegar primeiro e último nome
  const getNomeCurto = (nomeCompleto) => {
    if (!nomeCompleto) return "Usuário";
    const partes = nomeCompleto.trim().split(" ");
    if (partes.length === 1) return partes[0];
    return `${partes[0]} ${partes[partes.length - 1]}`;
  };

  return (
    <div className="relative bg-[#003D42] p-4 flex justify-between items-center" style={{
    backgroundColor: "#003D42",
    paddingTop: `calc(env(safe-area-inset-top) + 0.5rem)`,
    paddingBottom: "0.5rem",
  }}>
      {/* Logo */}
      <img
        src={logo}
        alt="Logo"
        className="h-20 cursor-pointer"
        onClick={() => window.location.href = "/area-restrita/colaborador"}
      />

      {/* Perfil e submenu */}
      <div className="relative">
        <button
          onClick={toggleSubMenu}
          className="flex items-center space-x-3 focus:outline-none"
          aria-haspopup="true"
          aria-expanded={subMenuVisible}
        >
          <div className="h-12 w-12 rounded-full overflow-hidden border-2 border-white">
            <img
              src={fotoUsuario}
              alt={nomeUsuario}
              className="object-cover h-full w-full"
            />
          </div>
          <span className="text-white font-semibold select-none">
            {getNomeCurto(nomeUsuario)}
          </span>
          {subMenuVisible ? (
            <ChevronUp size={22} color="white" />
          ) : (
            <ChevronDown size={22} color="white" />
          )}
        </button>

        {subMenuVisible && (
          <div className="absolute right-0 mt-2 w-48 bg-white shadow-lg border border-solid border-gray-300 z-50">
            <button
              onClick={MinhaConta}
              className="flex items-center w-full px-4 py-2 text-gray-700 bg-white hover:bg-gray-100"
            >
              <User size={18} className="mr-2" />
              Minha Conta
            </button>
            <button
              onClick={TermosDeUso}
              className="flex items-center w-full px-4 py-2 text-gray-700 bg-white hover:bg-gray-100"
            >
              <FileText size={18} className="mr-2" />
              Termos
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
